export default "skymp5-front/baad6bdaa1476fd3794bef02c612cc05.gif";